export * from './new-paginator/new-paginator.component';
export * from './pagination.module';
export * from './per-page/per-page.component';
